import { render, staticRenderFns } from "./reviewpdp.vue?vue&type=template&id=de90d1d4&scoped=true"
import script from "./reviewpdp.vue?vue&type=script&lang=js"
export * from "./reviewpdp.vue?vue&type=script&lang=js"
import style0 from "./reviewpdp.vue?vue&type=style&index=0&id=de90d1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de90d1d4",
  null
  
)

export default component.exports